import {
  alignCenterCellStyle,
} from '@common/cellStyles';
import {
  companyCodeColumnDefinition,
  companyCodeLinkColumnDefinition,
  ccDescriptionColumnDefinition,
  accountColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  geographyColumnDefinition,
  projectColumnDefinition,
  referenceColumnDefinition,
  bookTypeColumnDefinition,
  productLineColumnDefinition,
  enteredCurrencyColumnDefinition,
  enteredDebitColumnDefinition,
  enteredCreditColumnDefinition,
  accountDescriptionColumnDefinition,
  legalEntityColumnDefinition,
  managementEntityColumnDefinition,
  localAccountColumnDefinition,
  ileColumnDefinition,
  imeColumnDefinition,
  localAccountDescriptionColumnDefinition,
  statusColumnDefinition,
  notesColumnDefinition,
  connectionNameColumnDefinition,
  countryNameColumnDefinition,
  updatedOnColumnDefinition,
  importResultsColumnDefinition,
} from '../columnDefinitions';

export const defaultColumnDefs = {
  ...alignCenterCellStyle,
};

export const commonColumnDefs = [
  companyCodeLinkColumnDefinition,
  ccDescriptionColumnDefinition,
  legalEntityColumnDefinition,
  { ...countryNameColumnDefinition, headerName: 'Country' },
];

export const allProvisionsColumnDefs = [
  ...commonColumnDefs,
  statusColumnDefinition,
  { ...updatedOnColumnDefinition, headerName: 'Last Update' },
];

export const processedSuccessfullyColumnDefs = [
  ...commonColumnDefs,
  { ...updatedOnColumnDefinition, headerName: 'Date Time' },
  statusColumnDefinition,
];

export const trialBalancesNotReceivedColumnDefs = [
  ...commonColumnDefs,
  statusColumnDefinition,
];

export const trialBalancesValidationErrorsColumnDefs = [
  ...commonColumnDefs,
  importResultsColumnDefinition,
  statusColumnDefinition,
];

export const calculationErrorsColumnDefs = [
  ...commonColumnDefs,
  statusColumnDefinition,
];

export const otherErrorsColumnDefs = [
  connectionNameColumnDefinition,
  companyCodeColumnDefinition,
  notesColumnDefinition,
];

export const journalsColumnDefs = [
  companyCodeColumnDefinition,
  accountColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  geographyColumnDefinition,
  projectColumnDefinition,
  referenceColumnDefinition,
  bookTypeColumnDefinition,
  productLineColumnDefinition,
  enteredCurrencyColumnDefinition,
  enteredDebitColumnDefinition,
  enteredCreditColumnDefinition,
  accountDescriptionColumnDefinition,
];

export const localJournalsColumnDefs = [
  legalEntityColumnDefinition,
  managementEntityColumnDefinition,
  localAccountColumnDefinition,
  ileColumnDefinition,
  imeColumnDefinition,
  bookTypeColumnDefinition,
  enteredCurrencyColumnDefinition,
  enteredDebitColumnDefinition,
  enteredCreditColumnDefinition,
  localAccountDescriptionColumnDefinition,
];
